import { HandleTextChange, HandleCheckChange, RadioHandler, CallAPI, HandleSignatureChange, GetCookieFunction, parseIntFromStr, GetTzAwareTime } from '../../utils/util';
import React, { Component } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { PatientNav } from './patientnav';
import VoiceInput from '../../utils/VoiceInput';
import Alert from 'react-bootstrap/Alert';

function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();
        return <Component {...props} router={{ location, navigate, params }} />;
    }
    return ComponentWithRouterProp;
}

class Vitals extends Component {
    constructor(props) {
        super(props);
        this.state = {
            patientID: parseIntFromStr(this.props.router.params.patientId),
            centerID: GetCookieFunction("Center").id,
            p_vitalsHistory: [],
            BP: "", HR: "", BFR: "", DFR: "", AP: "", VP: "", TMP: "", UFR: "", FluidRemoved: "",
            Haparrin: "", NSFlush: "", Safety: "", Access_Flow: "",
            time: 0, Comments: "", modalVariant: "", modalMessage: ""
        };
        this.handleTextChange = HandleTextChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.radioHandler = RadioHandler.bind(this);
        this.handleCheckChange = HandleCheckChange.bind(this);
        this.handleSignatureChange = HandleSignatureChange.bind(this);
    }

    componentDidMount() {
        CallAPI({}, `patients/${this.state.patientID}/vitals`, 'GET', (res) => {
            this.setState({ p_vitalsHistory: res || [] });
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        CallAPI(this.state, `patients/${this.state.patientID}/vitals`, 'POST', (res) => {
            if (res) this.props.router.navigate(`/patients/${this.state.patientID}/profile`);
        }, (message) => {
            this.setState({ modalVariant: "danger", modalMessage: "Failed to save: " + (message.message ?? "") });
        });
    }

    render = () => {
        const r = (e) => this.radioHandler(e);
        const tz = GetCookieFunction("User").tz;

        return (
            <div>
                <PatientNav patientId={this.state.patientID} />

                <div className="ci-page">
                    <div className="ci-header">
                        <h2>Record HD Vitals</h2>
                        <p>Document hemodialysis treatment parameters</p>
                        {this.state.p_vitalsHistory && this.state.p_vitalsHistory.length > 0 && (
                            <a href="#previous-readings" style={{
                                fontSize: '14px', color: 'var(--primary)', marginTop: '10px', display: 'inline-flex',
                                alignItems: 'center', gap: '6px', fontWeight: 600,
                                padding: '6px 12px', background: 'var(--primary-light)', borderRadius: 'var(--radius-sm)',
                                textDecoration: 'none'
                            }}>
                                📋 {this.state.p_vitalsHistory.length} previous reading{this.state.p_vitalsHistory.length !== 1 ? 's' : ''} ↓
                            </a>
                        )}
                    </div>

                    {this.state.modalVariant && (
                        <Alert variant={this.state.modalVariant} className="ci-alert">{this.state.modalMessage}</Alert>
                    )}

                    <form onSubmit={(e) => this.handleSubmit(e)}>

                        {/* Access Flow */}
                        <div className="ci-card">
                            <div className="ci-card-label">Access Flow<span className="ci-required">*</span></div>
                            <div className="ci-radio-group">
                                <label className="ci-radio-option">
                                    <input type="radio" id="Access_Flow1" name="Access_Flow" value="GOOD"
                                        required checked={this.state.Access_Flow === "GOOD"} onChange={r} />
                                    <span>Good</span>
                                </label>
                                <label className="ci-radio-option">
                                    <input type="radio" id="Access_Flow2" name="Access_Flow" value="POOR"
                                        checked={this.state.Access_Flow === "POOR"} onChange={r} />
                                    <span>Poor</span>
                                </label>
                            </div>
                        </div>

                        {/* Treatment Parameters */}
                        <div className="ci-section-title">Treatment Parameters</div>
                        <div className="ci-card">
                            <div className="ci-grid">
                                <div className="ci-field">
                                    <label htmlFor="BP" className="ci-required-label">Blood Pressure (BP)</label>
                                    <input type="text" id="BP" name="BP" required
                                        pattern="\d{2,3}\/\d{2,3}" title="e.g. 120/80"
                                        placeholder="120/80"
                                        onChange={(e) => this.handleTextChange(e)} />
                                </div>
                                <div className="ci-field">
                                    <label htmlFor="HR">Heart Rate (HR)</label>
                                    <input type="number" id="HR" name="HR"
                                        min="40" max="200" placeholder="bpm"
                                        onChange={(e) => this.handleTextChange(e)} />
                                </div>
                                <div className="ci-field">
                                    <label htmlFor="bfr" className="ci-required-label">Blood Flow Rate (QB)</label>
                                    <input type="number" id="bfr" name="BFR" required
                                        placeholder="mL/min"
                                        onChange={(e) => this.handleTextChange(e)} />
                                </div>
                                <div className="ci-field">
                                    <label htmlFor="dfr" className="ci-required-label">Dialysate Flow Rate (QD)</label>
                                    <input type="number" id="dfr" name="DFR" required
                                        placeholder="mL/min"
                                        onChange={(e) => this.handleTextChange(e)} />
                                </div>
                                <div className="ci-field">
                                    <label htmlFor="ap" className="ci-required-label">Arterial Pressure (AP)</label>
                                    <input type="number" id="ap" name="AP" required
                                        placeholder="mmHg"
                                        onChange={(e) => this.handleTextChange(e)} />
                                </div>
                                <div className="ci-field">
                                    <label htmlFor="vp" className="ci-required-label">Venous Pressure (VP)</label>
                                    <input type="number" id="vp" name="VP" required
                                        placeholder="mmHg"
                                        onChange={(e) => this.handleTextChange(e)} />
                                </div>
                                <div className="ci-field">
                                    <label htmlFor="tmp" className="ci-required-label">TMP</label>
                                    <input type="number" id="tmp" name="TMP" required
                                        placeholder="mmHg"
                                        onChange={(e) => this.handleTextChange(e)} />
                                </div>
                                <div className="ci-field">
                                    <label htmlFor="UFR" className="ci-required-label">UF Rate (UFR)</label>
                                    <input type="number" id="UFR" name="UFR" required
                                        min="0" max="2000" placeholder="mL/hr"
                                        onChange={(e) => this.handleTextChange(e)} />
                                </div>
                                <div className="ci-field">
                                    <label htmlFor="FluidRemoved">Fluid Removed</label>
                                    <input type="number" id="FluidRemoved" name="FluidRemoved"
                                        min="0" max="5000" placeholder="mL"
                                        onChange={(e) => this.handleTextChange(e)} />
                                </div>
                                <div className="ci-field">
                                    <label htmlFor="haparrin">Heparin (units)</label>
                                    <input type="number" id="haparrin" name="Haparrin"
                                        placeholder="Optional"
                                        onChange={(e) => this.handleTextChange(e)} />
                                </div>
                                <div className="ci-field">
                                    <label htmlFor="NSFlush">Saline NS Flush</label>
                                    <input type="number" id="NSFlush" name="NSFlush"
                                        placeholder="mL"
                                        onChange={(e) => this.handleTextChange(e)} />
                                </div>
                            </div>
                        </div>

                        {/* Comments & Signature */}
                        <div className="ci-section-title">Notes &amp; Signature</div>
                        <div className="ci-card">
                            <div className="ci-field">
                                <label htmlFor="Comments">Notes</label>
                                <div className="ci-field-with-voice">
                                    <textarea id="Comments" name="Comments" maxLength="500" rows={3}
                                        placeholder="Any observations or notes..."
                                        value={this.state.Comments}
                                        onChange={(e) => this.handleTextChange(e)} />
                                    <VoiceInput language="en" onTranscript={(text) => {
                                        this.setState(prev => ({
                                            Comments: (prev.Comments || "") + (prev.Comments ? " " : "") + text
                                        }));
                                    }} />
                                </div>
                            </div>
                        </div>

                        <div className="ci-card">
                            <label className="ci-checkbox-label">
                                <input type="checkbox" name="Safety" required
                                    onChange={(e) => this.handleCheckChange(e)} />
                                <span>Safety check completed</span>
                            </label>
                        </div>

                        <div className="ci-card">
                            <label className="ci-checkbox-label ci-signature">
                                <input type="checkbox" name="Signature" required
                                    onChange={(e) => { this.handleCheckChange(e); this.handleSignatureChange(e, this); }} />
                                <span>I confirm the above information is accurate <em>(electronic signature)</em></span>
                            </label>
                        </div>

                        <div className="ci-submit-row">
                            <button type="submit" className="logSubmit ci-submit-btn">Submit Vitals</button>
                        </div>
                    </form>

                    {/* Past Vitals History */}
                    {this.state.p_vitalsHistory && this.state.p_vitalsHistory.length > 0 && (
                        <>
                            <div className="ci-section-title" id="previous-readings" style={{ marginTop: '32px' }}>Previous Readings</div>
                            {this.state.p_vitalsHistory.map((row) => (
                                <div key={row.Vitals_ID} className="ci-card" style={{marginBottom: '12px'}}>
                                    <div style={{marginBottom: '10px', borderBottom: '1px solid var(--border)', paddingBottom: '8px'}}>
                                        <span style={{fontSize: '13px', fontWeight: 600, color: 'var(--text-primary)'}}>{GetTzAwareTime(row.Time, tz, true)}</span>
                                        {row.staffName && <span style={{fontSize: '13px', fontWeight: 600, color: 'var(--text-primary)', marginLeft: '8px'}}>· {row.staffName}</span>}
                                    </div>
                                    <div className="vh-vital-grid">
                                        <div className="vh-vital-item"><span style={{color:'#dc2626'}}>BP</span><b>{row.BP}</b></div>
                                        {row.HR && <div className="vh-vital-item"><span style={{color:'#9333ea'}}>HR</span><b>{row.HR} bpm</b></div>}
                                        <div className="vh-vital-item"><span style={{color:'#2563eb'}}>QB</span><b>{row.BFR} mL/min</b></div>
                                        <div className="vh-vital-item"><span style={{color:'#0891b2'}}>QD</span><b>{row.DFR} mL/min</b></div>
                                        <div className="vh-vital-item"><span style={{color:'#ea580c'}}>AP</span><b>{row.AP} mmHg</b></div>
                                        <div className="vh-vital-item"><span style={{color:'#db2777'}}>VP</span><b>{row.VP} mmHg</b></div>
                                        <div className="vh-vital-item"><span style={{color:'#16a34a'}}>TMP</span><b>{row.TMP} mmHg</b></div>
                                        <div className="vh-vital-item"><span style={{color:'#7c3aed'}}>UFR</span><b>{row.UFR} mL/hr</b></div>
                                        {row.FluidRemoved && <div className="vh-vital-item"><span style={{color:'#0d9488'}}>Fld Rmvd</span><b>{row.FluidRemoved} mL</b></div>}
                                    </div>
                                </div>
                            ))}
                        </>
                    )}
                </div>
            </div>
        );
    };
}

export default withRouter(Vitals);
